import { Link } from 'react-router-dom';
import styles from './Vendor.module.scss';
import Feedback from '../Feedback/Feedback';
import ProfileCard from '../ProfileCard/ProfileCard';
import VendorDetails from '../VendorDetails/VendorDetails';


export default function Vendor(props) {

  return (
    <>
        <div className={`bg-white p-4 ${styles.lgtBackground}`}>
            <div className={`${styles.sellerWrapper}`}>
                <div className={`${styles.lgtAboutSeller}`}>
                    <Link to={`/vendor/${props.user.id}`}>
                        About the seller
                        <i className="bi bi-chevron-right"></i>
                    </Link>
                </div>
                <div className='mb-3'>
                    <ProfileCard 
                        isArrow={false}
                        id={props.user.id}
                        firstName={props.user.first_name}
                        lastName={props.user.last_name}
                        avatar={props.user.avatar}
                        username={props.user.username}
                    />
                </div>
                <div className='bottonDivider mb-3'></div>
                    <Feedback userId={props.user.id} />
                <div className='bottonDivider mb-3'></div>
                {
                    props.user &&
                    <div className='mb-3'>
                        <VendorDetails user={props.user} />
                    </div>
                }
                <div>
                    <Link   className={`btn ${styles.blueBtn} text-decoration-none`}
                            to={`/product-list/?user_id=${props.user.id}`}>
                        Seller's store
                        <i className="bi bi-shop-window ps-2"></i>
                    </Link>
                </div>
            </div>
        </div>
    </>
  )
}
